import { VizType } from "@atlas-int/data";
import styled from "@emotion/styled";
import {
  fontSize,
  lineHeight,
  spacing,
  brand,
  text,
} from "@atlas-int/tokens";
import { vizTypeIcons } from "../../assets/icons";

interface Props {
  vizType: VizType;
}

const VizTypeListItem = styled.li`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  margin: 0px 0px;
  padding: ${spacing[2]};
  color: ${text.onDark};
  text-align: center;
  text-transform: uppercase;
  flex: 1 0 0px;
  font-size: ${fontSize.xs};
  line-height: ${lineHeight.snug};
  box-sizing: border-box;

  & img {
    width: 100%;
    max-height: 20px;
    margin-top: 3px;
  }

  &.selected {
    background-color: ${brand.dark};
  }
`;

const LabelText = styled.span`
  min-height: 2.6em;
  display: flex;
  align-items: center;
  white-space: pre-line;
`;

export default function VizTypeSelectorButton({ vizType }: Props) {
  let buttonLabel: string | undefined;
  let buttonIcon;

  if (vizType === VizType.Tree) {
    buttonLabel = "Trade Composition";
    buttonIcon = vizTypeIcons.treemapWhite;
  } else if (vizType === VizType.Geo) {
    buttonLabel = "Trade\nMap";
    buttonIcon = vizTypeIcons.geomapWhite;
  } else if (vizType === VizType.OverTime) {
    buttonLabel = "Trade Over Time";
    buttonIcon = vizTypeIcons.overtimeWhite;
  } else if (vizType === VizType.MarketShare) {
    buttonLabel = "Global\nShare";
    buttonIcon = vizTypeIcons.globalshareWhite;
  } else if (vizType === VizType.ProductSpace) {
    buttonLabel = "Product\nSpace";
    buttonIcon = vizTypeIcons.productspaceWhite;
  } else if (vizType === VizType.Feasibility) {
    buttonLabel = "Growth Opportunity";
    buttonIcon = vizTypeIcons.feasibilityWhite;
  }

  return (
    <VizTypeListItem>
      <LabelText>{buttonLabel}</LabelText>
      <img src={buttonIcon} alt={`${buttonLabel} visualization`} />
    </VizTypeListItem>
  );
}
